import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import UserProfileLink from "../../user/user_profile_link";

export default GrComponentFactory.createClass({
  displayName: "RecommendationHeader",

  propTypes: {
    toUser: GrPropTypes.user().isRequired,
    recommendedToYou: React.PropTypes.bool,
  },

  render(){
    if (this.props.recommendedToYou) {
      return <span>{"recommended a book to you"}</span>;
    } else {
      return <span>
        {"recommended a book to "}
        <UserProfileLink user={this.props.toUser}/>
      </span>;
    }
  },
});
